/**
 * Pass types supported by the GetPasses API.
 * Used across all portals (Family, Educator, Show Admin) to filter passes.
 */
export enum PassType {
  /** Standard exhibitor passes - available in all portals */
  EXHIBITOR = 'exhibitor',

  /** Educator/AST/CEA passes - available only in educator portal */
  EDUCATOR = 'educator',

  /** Premium passes with club-level quantity limits - available in educator and family portals */
  PREMIUM = 'premium'
}

/**
 * Determine the default pass type for a portal.
 *
 * @param portal - The portal type ('family', 'educator', 'show-admin')
 * @returns The appropriate default pass type for that portal
 */
export function getDefaultPassType(
  portal: 'family' | 'educator' | 'show-admin'
): PassType {
  // All portals default to exhibitor passes for entry forms and carts
  // (exhibitor passes are the most common across all portals)
  return PassType.EXHIBITOR;
}
